import { useBreakpointValue } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import { EEventType } from '@/modules/events/utilities';

import { usePermissions } from './usePermissions';

const NAVIGATE_BACK = 'NAVIGATE_BACK';

type useLeaveMobileVirtualEventProps = {
  eventType: EEventType;
};

export const useLeaveMobileVirtualEvent = ({
  eventType,
}: useLeaveMobileVirtualEventProps): {
  onDisconnect: (() => void) | undefined;
} => {
  const isMobile = !!useBreakpointValue({
    base: true,
    md: false,
  });

  const router = useRouter();
  const { canAccessEventsFeed } = usePermissions();
  const navigateBackWebview = () => {
    // @ts-ignore
    if (window.ReactNativeWebView) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(NAVIGATE_BACK);
    } else if (!isMobile) {
      return;
    } else if (eventType === EEventType.CONFERENCE) {
      const { eventId } = router.query;
      router.push(`/events/conferences/${eventId.toString()}/reception`);
    } else if (canAccessEventsFeed) {
      router.push('/events');
    } else {
      router.push('/');
    }
  };

  return { onDisconnect: navigateBackWebview };
};
